export const replaceSpacesWithHyphens = (inputString: string): string => {
  return inputString.replace(/\s+/g, "-");
};
